import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({ name: 'replaceNewLine' })
export class ReplaceNewLinePipe implements PipeTransform {
    transform(value: string, parameters: any): string {
        if (typeof (value) === 'string') {
            return value.replace(/\\n/g, "<br />")
        } else { return ''; }
    }
}